module.exports = __webpack_public_path__ + "static/logo-657a3d71aeaeec314b901dc83a41a0fd.png";